import { Menu } from 'antd';
import styled from 'styled-components';

const { SubMenu: AntdSubMenu } = Menu;

export const SpaceMenuTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubMenu = styled(AntdSubMenu)`
  .ant-menu-item-selected {
    background: var(--coolest-gray-10);
  }

  .ant-menu-submenu-title:hover,
  .ant-menu-item:not(.ant-menu-item-selected):hover {
    background: var(--item-hover-bg);
  }

  &.ant-menu-submenu {
    &-active,
    &-selected,
    .ant-menu-submenu-title,
    .ant-menu-item a {
      &,
      &:hover {
        color: var(--text-color);
      }
    }

    .more-actions {
      opacity: 0;
    }

    .ant-menu-item,
    .ant-menu-submenu-title {
      border: 0px;
      height: var(--height-base);
      line-height: var(--height-base);
      margin-bottom: 0px;
      margin-top: 0px;

      > span {
        flex: 1;
        width: calc(100% - var(--input-size-sm));
      }

      &:hover {
        .more-actions {
          opacity: 1;
        }
      }
    }

    .ant-menu-item {
      padding-left: 40px !important;

      &-icon {
        min-width: var(--input-size-sm);
      }
    }

    .ant-menu-item-selected.ant-menu-item a {
      &,
      &:hover,
      &:active,
      &:focus {
        color: var(--primary-color);
      }
    }

    &-selected ${SpaceMenuTitle} {
      font-weight: var(--font-weight-bold);
    }
  }
`;
